/* eslint-disable import/prefer-default-export */
import { LOTUS, LOLA } from './constants';

export const lotusOrLola = model => model === LOTUS || model === LOLA;



// WEBPACK FOOTER //
// ./src/common/forecast.js